import { LucideIcon } from "lucide-react";

interface NoPreviewCardProps {
    Icon: LucideIcon;
    title: string;
    description: string;
    cardTitle: string;
}

const NoPreviewCard = ({ Icon, title, description, cardTitle }: NoPreviewCardProps) => {
    return (
        <div className="flex flex-col gap-4 bg-white rounded-lg border border-[#E6E6E6] shadow-sm">
           <div className="px-6 py-4 flex gap-2 border-b border-[#DCDCDE] w-full">
           <h2 className="text-lg font-medium text-[#2D2F35] text-left">{cardTitle}</h2>
           </div>
            <div className="px-4 py-6 flex flex-col items-center justify-center gap-2 self-center">
                <Icon className="size-16 text-[#FFAB1F]" />
                <h2 className="text-lg font-medium text-[#2D2F35]">{title}</h2>
                <p className="text-sm text-[#667085] text-center">{description}</p>
            </div>
        </div>
    );
};

export default NoPreviewCard;